import * as api from '../../../apis/terms'
import { createSelector } from 'reselect'
import history from '../../../utilties/history'
import browserHistory from '../../../utilties/browserHistory'
import queryString from 'query-string'

const FETCH_TERMS_REQUESTED = 'FETCH_TERMS_REQUESTED'
const FETCH_TERMS_SUCCESS = 'FETCH_TERMS_SUCCESS'
const FETCH_TERMS_FAILED = 'FETCH_TERMS_FAILED'

export const fetchTerms = (circleId, language) => (dispatch) => {
	dispatch({ type: FETCH_TERMS_REQUESTED, data: {} })
	api.fetchTerms(circleId, language).then((response) => {
		if (response && response.isSuccessful) {
			return dispatch({ type: FETCH_TERMS_SUCCESS, data: response })
		} else if(!response || !response.redirectTo) {
			return dispatch({ type: FETCH_TERMS_FAILED, data: {} })
		}
	})
	return
}

export const fetchTermsByPatientEmail = (email, language) => (dispatch) => {
	dispatch({ type: FETCH_TERMS_REQUESTED, data: {} })
	api.fetchTermsByPatientEmail(email, language).then((response) => {
		if (response && response.isSuccessful) {
			return dispatch({ type: FETCH_TERMS_SUCCESS, data: response })
		} else if(!response || !response.redirectTo) {
			return dispatch({ type: FETCH_TERMS_FAILED, data: {} })
		}
	})
	return
}

const FETCH_TERM_REQUESTED = 'FETCH_TERM_REQUESTED'
const FETCH_TERM_SUCCESS = 'FETCH_TERM_SUCCESS'
const FETCH_TERM_FAILED = 'FETCH_TERM_FAILED'

export const fetchTerm = (id) => (dispatch) => {
	dispatch({ type: FETCH_TERM_REQUESTED, data: {} })

	api.fetchTerm(id).then((response) => {
        if (response && response.isSuccessful) {
            return dispatch({ type: FETCH_TERM_SUCCESS, data: response.data })
		} else if(!response || !response.redirectTo) {
            return dispatch({ type: FETCH_TERM_FAILED, data: {} })
        }
	})

    return
}

const FETCH_IS_CIRCLE_TERMS_ACCEPTED_REQUESTED = 'FETCH_IS_CIRCLE_TERMS_ACCEPTED_REQUESTED'
const FETCH_IS_CIRCLE_TERMS_ACCEPTED_SUCCESS = 'FETCH_IS_CIRCLE_TERMS_ACCEPTED_SUCCESS'
const FETCH_IS_CIRCLE_TERMS_ACCEPTED_FAILED = 'FETCH_IS_CIRCLE_TERMS_ACCEPTED_FAILED'

export const getIsCircleTermsAccepted = (patientId) => (dispatch) => {
	dispatch({ type: FETCH_IS_CIRCLE_TERMS_ACCEPTED_REQUESTED, data: {} })

	api.fetchIsCircleTermsAccepted(patientId).then((response) => {
        if (response && response.isSuccessful) {
            return dispatch({ type: FETCH_IS_CIRCLE_TERMS_ACCEPTED_SUCCESS, data: response.data })
		} else if(!response || !response.redirectTo) {
            return dispatch({ type: FETCH_IS_CIRCLE_TERMS_ACCEPTED_FAILED, data: {} })
        }
	})

    return
}

const ACCEPT_CIRCLE_TERMS_REQUESTED = 'ACCEPT_CIRCLE_TERMS_REQUESTED'
const ACCEPT_CIRCLE_TERMS_SUCCESS = 'ACCEPT_CIRCLE_TERMS_SUCCESS'
const ACCEPT_CIRCLE_TERMS_FAILED = 'ACCEPT_CIRCLE_TERMS_FAILED'

export const acceptCircleTerms = (circleId, patientId) => (dispatch) => {
	dispatch({ type: ACCEPT_CIRCLE_TERMS_REQUESTED, data: {} })

	api.fetchAcceptCircleTerms(circleId, patientId).then((response) => {
        if (response && response.isSuccessful) {
			var result = dispatch({ type: ACCEPT_CIRCLE_TERMS_SUCCESS, data: {} })
	
			let params = queryString.parse(browserHistory.location.search)
			history.push(params.returnUrl)
            return result
		} else if(!response || !response.redirectTo) {
            return dispatch({ type: ACCEPT_CIRCLE_TERMS_FAILED, data: {} })
        }
	})

    return
}

const initial = {
	configuration: {},
	term: null,
	circleTermsAccepted: null
}

export const reducer = (state = initial, action) => {
	switch (action.type) {
		case FETCH_TERMS_SUCCESS:
			return { ...state, terms: action.data }
        case FETCH_TERM_SUCCESS:
            return { ...state, term: action.data }
		case FETCH_IS_CIRCLE_TERMS_ACCEPTED_SUCCESS:
			return { ...state, circleTermsAccepted: action.data }
		case ACCEPT_CIRCLE_TERMS_SUCCESS:
			return { ...state, circleTermsAccepted: true }
		case 'SIGN_OUT_REQUESTED':
			return initial
		default:
			return { ...state }
	}
}

const mainSelector = (state) => state.configuration

export const termSelector = createSelector(mainSelector, (state) => {
	return state && state.term;
})

export const termsSelector = createSelector(mainSelector, (state) => {
	return state && state.terms && state.terms.internal
})

export const thirdPartyTermsSelector = createSelector(mainSelector, (state) => {
	return state && state.terms && state.terms.thirdParty
})

export const isCircleTermsAcceptedSelector = createSelector(mainSelector, (state) => {
	return state && state.circleTermsAccepted
})
